import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { message, Spin } from "antd";
import { MakeApiCall } from "../../../apis";
import {
  DefaultAdminPage,
  DefaultUserPage,
  Types,
} from "../../../config";
import { setData } from "../../../redux/actions";

const findRoutes = {
  superAdmin: DefaultAdminPage,
  admin: DefaultAdminPage,
  manager: DefaultAdminPage,
  user: DefaultUserPage,
};

export default function DemoLogin() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState(null);
  const calledRef = useRef(false);

  const handleDemoLogin = async () => {
    if (calledRef.current) return;
    calledRef.current = true;

    try {
      const response = await MakeApiCall("demo-user-login", "post", {});

      if (response?.status === true) {
        const type = Types?.[response?.data?.user_data?.user_type];
        const obj = {
          user: response.data,
          loginType: type,
          token: response.data?.auth_token_data?.access_token,
        };

        dispatch(setData(obj));
        message.success("Logged in as Demo User");

        const source = searchParams.get("source");
        if (source) {
          console.log("Demo Login Triggered — source:", source);
        }

        navigate(findRoutes?.[type] || "/dashboard", { replace: true });
      } else {
        setError(
          response?.message || "Unable to load demo account. Please try again."
        );
      }
    } catch (err) {
      setError("Unable to load demo account. Please try again.");
    }
  };

  useEffect(() => {
    handleDemoLogin();
  }, []);

  if (error) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#F1F2F4",
        }}
      >
        <div
          style={{
            textAlign: "center",
            padding: "48px 40px",
            borderRadius: 16,
            background: "#fff",
            boxShadow: "0 8px 40px rgba(0,0,0,0.14)",
            maxWidth: 460,
            width: "90%",
          }}
        >
          <img
            src="/assets/media/SellerViewLogo.png"
            alt="Seller View"
            style={{ width: 160, marginBottom: 24 }}
          />
          <h3
            style={{
              fontSize: 22,
              fontWeight: 700,
              marginBottom: 8,
              color: "#1a1a2e",
            }}
          >
            Demo Login Failed
          </h3>
          <p
            style={{
              color: "#888",
              fontSize: 14,
              marginBottom: 28,
              lineHeight: 1.6,
            }}
          >
            {error}
          </p>
          <button
            className="btn btn-danger"
            onClick={() => {
              setError(null);
              calledRef.current = false;
              handleDemoLogin();
            }}
            style={{
              borderRadius: 8,
              fontWeight: 600,
              padding: "10px 32px",
              fontSize: 15,
            }}
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "#F1F2F4",
        gap: 16,
      }}
    >
      <img
        src="/assets/media/SellerViewLogo.png"
        alt="Seller View"
        style={{ width: 180, marginBottom: 12 }}
      />
      <Spin size="large" />
      <p style={{ color: "#888", fontSize: 14 }}>
        Setting up your demo account…
      </p>
    </div>
  );
}

